import {
	ClientPortfolioDomainEnum,
	type PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const REPORTING_VALUE_DOMAINS: ClientPortfolioDomainEnum[] = [
	ClientPortfolioDomainEnum.PensionProducts,
	ClientPortfolioDomainEnum.BuildingSavings,
	ClientPortfolioDomainEnum.Investments,
	ClientPortfolioDomainEnum.Commodities,
	ClientPortfolioDomainEnum.BankingProducts,
	ClientPortfolioDomainEnum.Cryptocurrencies,
	ClientPortfolioDomainEnum.Loans,
	ClientPortfolioDomainEnum.BusinessLoans,
	ClientPortfolioDomainEnum.Leasing,
];

export const getReportingPortfolioIds = (
	items: PortfolioListItemResponseDTO[],
): number[] =>
	items
		.filter(
			(item) =>
				item.domain !== undefined &&
				item.domain !== null &&
				REPORTING_VALUE_DOMAINS.includes(item.domain),
		)
		.map((item) => item.id);
